import React, { useEffect, useMemo, useState } from "react";
import dashboardStyle from "../../styles/Dashboard.module.css";

export function PaymentModalLoader() {
  return (
    <div className={dashboardStyle.paymentModalLoader}>
      <i className="bi bi-arrow-repeat" aria-hidden="true" />
      <p>Cargando formulario...</p>
    </div>
  );
}

export function PaymentField({ label, error, children }) {
  return (
    <div className={dashboardStyle.paymentField}>
      <label className={dashboardStyle.paymentFieldLabel}>{label}</label>
      {children}
      {error ? <p className={dashboardStyle.paymentError}>{error}</p> : null}
    </div>
  );
}

export function PaymentStaticField({ label, value, hint }) {
  return (
    <div className={dashboardStyle.paymentStaticCard}>
      <span className={dashboardStyle.paymentFieldLabel}>{label}</span>
      <p className={dashboardStyle.paymentStaticValue}>{value}</p>
      {hint ? <p className={dashboardStyle.paymentStaticHint}>{hint}</p> : null}
    </div>
  );
}

function PaymentReportForm({
  methodEyebrow = "Método elegido",
  methodName,
  methodDescription,
  illustrationSrc,
  illustrationAlt,
  children,
  file,
  fileInputRef,
  onFileChange,
  onClose,
  onSubmit,
  submitDisabled,
  submitLabel,
  uploadHint,
  uploadRequiredText,
}) {
  const [previewUrl, setPreviewUrl] = useState("");

  const isImageFile = useMemo(
    () => Boolean(file && file.type && file.type.startsWith("image/")),
    [file]
  );

  useEffect(() => {
    if (!file || !isImageFile) {
      setPreviewUrl("");
      return undefined;
    }

    const url = URL.createObjectURL(file);
    setPreviewUrl(url);

    return () => {
      URL.revokeObjectURL(url);
    };
  }, [file, isImageFile]);

  const openFilePicker = () => {
    if (fileInputRef?.current) {
      fileInputRef.current.click();
    }
  };

  return (
    <form onSubmit={onSubmit} className={dashboardStyle.paymentReportForm}>
      <div className={dashboardStyle.paymentReportIntro}>
        <span className={dashboardStyle.paymentReportMethod}>{methodEyebrow}</span>
        <h3 className={dashboardStyle.paymentReportMethodName}>{methodName}</h3>
        <p className={dashboardStyle.paymentReportMethodText}>{methodDescription}</p>
      </div>

      <div className={dashboardStyle.paymentReportGrid}>
        <div className={dashboardStyle.paymentReportFields}>{children}</div>

        <aside className={dashboardStyle.paymentReportAside}>
          {illustrationSrc ? (
            <div className={dashboardStyle.paymentIllustrationCard}>
              <img
                src={illustrationSrc}
                alt={illustrationAlt}
                className={dashboardStyle.paymentIllustrationImage}
              />
            </div>
          ) : null}

          <div className={dashboardStyle.paymentUploadCard}>
            <div className={dashboardStyle.paymentUploadHeader}>
              <span className={dashboardStyle.paymentUploadTitle}>Comprobante</span>
              <span className={dashboardStyle.paymentUploadMeta}>JPG, PNG o PDF</span>
            </div>

            <input
              className="form-control-file"
              type="file"
              accept=".pdf, .jpg, .png"
              style={{ display: "none" }}
              onChange={onFileChange}
              ref={fileInputRef}
            />

            {file ? (
              <div className={dashboardStyle.paymentUploadPreview}>
                <span className={dashboardStyle.paymentUploadFileBadge}>
                  <i className="bi bi-paperclip" aria-hidden="true" />
                  {file.name}
                </span>
                {previewUrl ? <img src={previewUrl} alt="Comprobante cargado" /> : null}
              </div>
            ) : (
              <div className={dashboardStyle.paymentUploadPlaceholder}>
                <div>
                  <i className="bi bi-cloud-arrow-up" aria-hidden="true" />
                  <p style={{ margin: "0.5rem 0 0" }}>Todavía no subiste el comprobante.</p>
                </div>
              </div>
            )}

            <div className={dashboardStyle.paymentUploadActions}>
              <button
                type="button"
                className={dashboardStyle.btnOutline}
                onClick={openFilePicker}
              >
                {file ? "Cambiar comprobante" : "Adjuntar comprobante"}
              </button>
              {uploadHint ? (
                <p className={dashboardStyle.paymentUploadHint}>{uploadHint}</p>
              ) : null}
              {!file && uploadRequiredText ? (
                <p className={dashboardStyle.paymentUploadRequired}>{uploadRequiredText}</p>
              ) : null}
            </div>
          </div>
        </aside>
      </div>

      <div className={dashboardStyle.modalFooter}>
        <button
          type="button"
          className={dashboardStyle.btnOutline}
          onClick={onClose}
        >
          Cerrar
        </button>
        <button
          type="submit"
          className={dashboardStyle.btnPrimary}
          disabled={submitDisabled}
        >
          {submitLabel}
        </button>
      </div>
    </form>
  );
}

export default PaymentReportForm;
